import type { SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

export const helpCenterManifest: SkillManifest = {
  key: 'help-center',
  name: 'Hilfe-Center',
  description:
    'Volltext-durchsuchbares Hilfe-Center mit Markdown-Kapiteln (Lunr-Index, clientseitig).',
  category: 'core',
  version: '0.1.0',
  enabledByDefault: true,
};

/**
 * Schlanker Skill-Descriptor — wird vom Bootstrap importiert, OHNE den schweren
 * Barrel (Lunr-Suchindex, Markdown-Kapitel, Video-Manifest) eager zu laden.
 * Das Hilfe-Center bringt bewusst keinen Knopf in die Kopfzeile: Der einzige
 * Einstieg ist der Eintrag „Hilfe" im Fußbereich der Seitenleiste
 * (`components/layout/nav-items.ts`). Die Seiten (`HelpCenterPage`, `searchHelp`,
 * Content) kommen über die Lazy-Route in App.tsx bzw. `VideoHint`.
 */
export const helpCenterSkill: FrontendSkill = {
  manifest: helpCenterManifest,
};
